import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Project} from "../../../shared/models/project";

@Component({
  selector: 'mbnm-shop-detail-buy-section',
  templateUrl: './shop-detail-buy-section.component.html',
  styleUrls: ['./shop-detail-buy-section.component.scss']
})
export class ShopDetailBuySectionComponent implements OnInit {

  constructor() { }

  @Input()
  product:any;

  ngOnInit() {
  }
}
